/**
 * structuredClone polyfill for older browsers
 * Safari < 15.4, Chrome < 98, Firefox < 94
 * Provides a fallback implementation using JSON serialization for simple objects
 */

if (typeof structuredClone === 'undefined') {
  (globalThis as typeof globalThis & { structuredClone: <T>(value: T) => T }).structuredClone =
    function structuredClonePolyfill<T>(value: T): T {
      // For null or undefined, return as-is
      if (value === null || value === undefined) {
        return value;
      }

      // For primitive types, return as-is
      if (typeof value !== 'object') {
        return value;
      }

      // For dates, create a new Date instance
      if (value instanceof Date) {
        return new Date(value.getTime()) as T;
      }

      // For arrays and objects, use JSON serialization as a simple fallback
      // This handles most common cases but doesn't handle:
      // - Functions, symbols, undefined values
      // - Circular references
      // - RegExp, Map, Set, etc.
      try {
        return JSON.parse(JSON.stringify(value)) as T;
      } catch {
        // Fallback for cases where JSON serialization fails
        // Return the original value (shallow copy risk, but better than crashing)
        return value;
      }
    };
}
